module.exports = __webpack_public_path__ + "static/media/hero-standing.4bddb666.png";